import React, { useState, useContext } from "react";
import ActionsContext from "common/ActionsContext";
import Modal from "common/Modal";

const ConfigAccessProfilesHelpModal = () => {
  const [open, setOpen] = useState(false);
  const actions = useContext(ActionsContext);
  actions.recv("open-help", function () {
    setOpen(true);
  });
  const doClose = () => setOpen(false);
  if (open !== true) {
    return null;
  }

  return (
    <Modal
      title="Access Profiles"
      onClose={doClose}
      content={() => (
        <React.Fragment>
          <p>
            Access Profiles. Define a condition to apply to traffic on the
            access side (end customer IP addresses).
          </p>
          <ul>
            <li>
              <b>NAME</b>: Profile name.
            </li>
            <li>
              <b>ADDRESS</b>: IP Address or range of end customers.
            </li>
            <li>
              <b>PROTOCOL</b>: Transport protocol. Possible values: TCP, UDP or
              any protocol.
            </li>
            <li>
              <b>PORT</b>: Port (only for TCP and UDP protocols).
            </li>
          </ul>
          <p>
            Click on the "Add profile" button to create a new empty profile.
          </p>
          <p>
            Press the <i className="material-icons valign-icon">more_vert</i>{" "}
            icon and then select the <b>Add Profile...</b> option to add a new
            profile entry.
          </p>
          <p>
            Click on the refresh{" "}
            <i className="material-icons valign-icon">refresh</i> icon to
            refresh profiles information. Pending changes, if any, will be lost
          </p>
          <h5> inside the profile list: </h5>
          <p>
            Click on the <i className="material-icons valign-icon">edit</i> icon
            to open the profile edition view.
          </p>
          <p>
            Click on the <i className="material-icons valign-icon">delete</i> to
            remove the profile.
          </p>
        </React.Fragment>
      )}
    />
  );
};

export default ConfigAccessProfilesHelpModal;
